/* import __COLOCATED_TEMPLATE__ from './review-wrapper-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();